import { render } from "./TabBordered.vue?vue&type=template&id=5d7a816a&scoped=true"
import script from "./TabBordered.vue?vue&type=script&lang=js"
export * from "./TabBordered.vue?vue&type=script&lang=js"

import "./TabBordered.vue?vue&type=style&index=0&id=5d7a816a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d7a816a"]])

export default __exports__